


































import {Component, Vue} from 'vue-property-decorator';
import {WaccaComic} from '@/model/WaccaComic';


@Component({
  components: {},
})
export default class Location extends Vue {

  modalOpen = false;
  modalUrl = '';
  comics: WaccaComic[] = [];

  created(): void {
    this.$axios.get<WaccaComic[]>('wacca/comics').then(resp => {
      this.comics = resp.data;
    })
  }

  show(url: string): void {
    this.modalUrl = url;
    this.modalOpen = true;
  }

  closeModal(): void {
    this.modalUrl = '';
    this.modalOpen = false;
  }

}
